import { render, staticRenderFns } from "./Suspension.vue?vue&type=template&id=f1330f68"
import script from "./Suspension.vue?vue&type=script&lang=js"
export * from "./Suspension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../car/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports